module.exports = __webpack_public_path__ + "img/range_bg.ae135171.png";